import React from "react";
import { Link } from "react-router-dom";

/*
 * Impact strip — honest counters that grow with the mission.
 * Values are maintained by hand; update as real outcomes occur
 * (see AGENTS.md Section 2: never fabricate results).
 */

const stats = [
  { value: "1", label: "Member helped — and counting" },
  { value: "12+", label: "Scams explained in plain language" },
  { value: "100%", label: "Free. Today, tomorrow, always" },
];

export function ImpactStrip() {
  return (
    <div
      className="w-full py-10"
      style={{ background: "linear-gradient(90deg, #0f172a, #36395a)" }}
    >
      <div className="mx-4 max-w-5xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
        {stats.map((s) => (
          <div key={s.label}>
            <p
              className="text-4xl font-extrabold bg-clip-text text-transparent"
              style={{ backgroundImage: "linear-gradient(90deg, #12bfbe, #9198e5)" }}
            >
              {s.value}
            </p>
            <p className="text-gray-300 text-sm mt-1">{s.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ImpactStrip;
